import mainRoutes from './main-routes'

/**
 * 路由表配置
 */
export default [
  // ## login page
  {
    name: 'login',
    path: '/login',
    meta: { requiresAuth: false },
    component: resolve => require.ensure([], () => resolve(require('views/login')), 'login')
  },
  {
    name: 'regedit',
    path: '/regedit/:source',
    meta: { requiresAuth: false },
    component: resolve => require.ensure([], () => resolve(require('views/regedit')), 'regedit')
  },
  {
    name: 'home',
    path: '/home',
    meta: { requiresAuth: false },
    component: resolve => require.ensure([], () => resolve(require('views/home')), 'home')
  },
  // ## main page
  {
    path: '/',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/layout')), 'common'),
    children: mainRoutes
  },
  // ## not found page
  {
    name: 'not-found',
    path: '*',
    meta: { requiresAuth: false },
    component: resolve => require.ensure([], () => resolve(require('views/error')), 'common')
  },
  // ## not found page
  {
    name: 'not404',
    path: '/404',
    meta: { requiresAuth: false },
    component: resolve => require.ensure([], () => resolve(require('views/error')), 'not404')
  }
]



// WEBPACK FOOTER //
// ./src/libraries/router/routes.js